import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import TextInfo, {
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_KIND,
  TEXT_HEADING_LEVEL,
  TEXT_DECORATION,
} from "@gc-npm/components.text";
import CustomizerComponent from "@gc-npm/components.customizer-component";
import Icon from "@gc-npm/components.icon-glyph";

import FiltersMobileButton from "@/component/filters-mobile-button";
import DeviceCard from "@/component/new-device-card";
import Searcher from "@/component/searcher";
import {
  generateQueryString,
  getCategoryTextById,
} from "@/utils/normalizers/product";
import Card from "@/component/cardBanner";
import { actions as modalActions } from "@gc-npm/reducers.modals-reducer";
import Button, {
  BUTTON_HEIGHT,
  BUTTON_TYPE,
  BUTTON_WIDTH,
} from "@gc-npm/components.button";
import CustomLink from "@gc-npm/components.custom-link";
import styles from "./style";
import FakeCardDevice from "@/component/fakes/devices/card";
import { getFullUrl, goLoginCallbackUrl } from "@/utils/htmlUtils";
import { USUARIO_NO_LOGADO, USUARIO_R2R_ADICIONAL_CON_RENOVACION, USUARIO_SEGUNDO_R2R_INCLUIDO } from "@/constants/get-my-products";
const FloatingAlert = dynamic(() => import("@/component/floating-alert"));
const Pagination = dynamic(() => import("@/component/pagination/pagination"));
const Filters = dynamic(() => import("@/component/Filters"));
const ButtonFilter = dynamic(() =>
  import("@/component/Filters/ButtonFilter/ButtonFilter")
);
const NotFound = dynamic(() => import("@/component/NotFound/notfound"));
const DeviceOrder = dynamic(() => import("@/component/deviceOrder"));
const FiltersModal = dynamic(() => import("@/modals/filters"));

const ModalErrorGetMyProduct = dynamic(() =>
  import("@/modals/error-my-product")
);

import CmsBlock from '@gc-npm/components.cms/cms-block';
import CmsAlert from "@gc-npm/components.cms-block.cms-alert";
import RoombaPriceBanner from "@/component/roomba-price-banner";
import WorldCupBanner from "@/component/world-cup-banner";
import FakeDevices from "@/component/fakes/devices";
import AlertNewR2R from "@/component/alert-new-r2r";

const Devices = ({ id, hash, orionInfo, orionAlias }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { query } = router;
  const {
    filters,
    selectedFilters,
    productsFetching,
    serverRender,
    productsCards,
    sort,
    sortingKeys,
    searcherQuery,
    filtersApplied,
    hasToShowR2RRenovationOffers,
    showRenewR2ROffersFilter,
    isRenewR2RBtl,
    pagination
  } = useSelector((state) => state.devicesList);

  const { getMyProductFailure, clientType, foc, includedR2RInfo, isUserNewModelR2R } = useSelector(
    (state) => state.getMyProducts
  );
  const {
    categoryName,
  } = useSelector((state) => state.pageInfo);

  const [orderSelected, setOrderSelected] = useState(sort);
  const [searcherSelected, setSearcherSelected] = useState(false);
  const [sortingKeysMap, setSortingKeysMap] = useState(sortingKeys);
  const [filtersData, setFiltersData] = useState(filters);

  useEffect(() => {
    if (getMyProductFailure) {
      dispatch(
        modalActions.addModal({
          type: "MODAL",
          id: "errorObtenerMisProductos",
          Element2Show: ModalErrorGetMyProduct,
          elementProps: {},
          modalProps: {
            contentPosition: "center--center",
            opacityLayoutColor: "black05",
            inSceneEffect: "fadeIn",
            outSceneEffect: "fadeOut",
            closeByClickingOutside: true,
          },
        })
      );
    }
  }, [getMyProductFailure]);

  useEffect(() => {
    if (sortingKeys !== sortingKeysMap) setSortingKeysMap(sortingKeys);

    if (sort !== orderSelected) setOrderSelected(sort);
  }, [sortingKeys, sort]);

  useEffect(() => {
    if (filters !== filtersData) setFiltersData(filters);
  }, [filters]);

  const saveScroll = () => {
    const scrollData = {
      scrollPosition: window.scrollY,
      lastId: router.query.id,
      lastVisit: new Date().getTime(),
    };
    localStorage.setItem("scrollData", JSON.stringify(scrollData));
  };

  useEffect(() => {
    const storedData = localStorage.getItem("scrollData");

    if (storedData) {
      const { scrollPosition, lastId, lastVisit } = JSON.parse(storedData);

      if (lastId === router.query.id) {
        const currentTime = new Date().getTime();
        const elapsedTime = currentTime - lastVisit;

        if (elapsedTime < 300000) {
          window.scrollTo(0, scrollPosition);
        }
      }

      localStorage.removeItem("scrollData");
    }
  }, []);

  const handleOnSubmitSearcher = (value) => {
    if (value.length >= 2 || value === "") {
      const selectedFiltersNew = selectedFilters;
      let url;
      selectedFiltersNew.query = value;
      //selectedFiltersNew.resultsFrom = 0;
      selectedFiltersNew.id = id;
      //dispatch(productActions.getProductsGeneric(selectedFiltersNew));
      url = getFullUrl(`${id}?sort=${sort}&${generateQueryString(selectedFiltersNew)
        }`, query);
      router.push(url, undefined, { shallow: true });
    }
  };

  const handleOnChangeSearcher = () => {
    //console.log(value);
  };

  const handleOnChangeOrder = (value) => {
    let url;
    const selectedFiltersNew = selectedFilters;
    selectedFiltersNew.sort = value;
    //selectedFiltersNew.resultsFrom = 0;
    selectedFiltersNew.id = id;
    if (searcherQuery) selectedFiltersNew.query = searcherQuery;
    url = getFullUrl(`/${id}?${generateQueryString(selectedFiltersNew)
      }`, query);
    router.push(url, undefined, { shallow: true });
  };

  const handleBlurSearcher = () => {
    setSearcherSelected(false);
  };

  const handleFocusSearcher = () => {
    setSearcherSelected(true);
  };

  const clearFilters = () => {
    const url = getFullUrl(`/${id}`, query, true)
    router.push(url, undefined, { shallow: true });
    //dispatch(productActions.getProductsGeneric({ id }));
  };

  const launchFiltersModal = () => {
    dispatch(
      modalActions.addModal({
        id: "FiltersModal",
        Element2Show: FiltersModal, // Contenido que se quiere mostrar en la modal
        modalProps: {
          historyBackOnClose: false,
          contentPosition: "center",
          inSceneEffect: "fadeIn",
          className: "ModalFilterContent",
          outSceneEffect: "fadeOut",
          opacityLayoutColor: "darkblue",
          closeByClickingOutside: true,
        },
        elementProps: {
          filters: filtersData,
        },
      })
    );
  };

  const handleCardClick = (product, index) => {
    saveScroll();
  }

  return (
    <section className="container devices-list">
      {productsFetching && (
        <FakeDevices />
      )}
      {clientType === USUARIO_SEGUNDO_R2R_INCLUIDO && !isUserNewModelR2R && (
        <FloatingAlert title={"¡Enhorabuena!"} allowClose>
          Ahora puedes llevarte un nuevo dispositivo desde 0 €/mes
        </FloatingAlert>
      )}
      {clientType === USUARIO_R2R_ADICIONAL_CON_RENOVACION && includedR2RInfo && !hasToShowR2RRenovationOffers && (
        <FloatingAlert title={"Tu dispositivo está próximo a vencer, renuévalo."} allowCollapse>
          Llévate uno nuevo desde 0 €/mes y quédate con tu {includedR2RInfo.productName} por {includedR2RInfo.cancellationFee}€
          <div>
            <Button
              className="floating-alert-button"
              label={"Ver mis ofertas de renovación"}
              type={BUTTON_TYPE.LINK}
              height={BUTTON_HEIGHT.SMALL}
              href={getFullUrl(`/${id}?customTags=renovacion&category=smartphone&sort=priceAsc`, query)}
            />
          </div>
        </FloatingAlert>
      )}
      {
        ((showRenewR2ROffersFilter && !isRenewR2RBtl)) &&
        //Alert if not logged or forced offer category
        (clientType === USUARIO_NO_LOGADO || foc) && (
          <FloatingAlert title={"Tu dispositivo está próximo a vencer, renuévalo."} allowCollapse>
            Identifícate para ver tus ofertas
            <div>
              <Button
                className="floating-alert-button"
                label={"Identifícate"}
                type={BUTTON_TYPE.LINK}
                height={BUTTON_HEIGHT.SMALL}
                href={goLoginCallbackUrl(window.location.href)}
              />
            </div>
          </FloatingAlert>
        )
      }
      <div
        className={
          serverRender
            ? "productsContainer productsContainerServer"
            : "productsContainer"
        }
      >
        <div className="filtersContainer">
          <div className="filtersHeader">
            <TextInfo
              text="FILTROS"
              size={TEXT_SIZE.SUBTITLE1}
              color={TEXT_COLOR.MOVISTAR_BLACK}
              fontType={TEXT_FONT_WEIGHT.BOLD}
            />
            {(filtersApplied > 0) && (
              <CustomLink
                onClick={clearFilters}
                taggingInfo={{
                  componentName: "filters",
                  componentVariation: "all",
                  componentContent: "Borrar filtros",
                  componentPerso: "",
                  componentProduct: "",
                }}
                className="ButtonClearFilters"
              >
                <TextInfo
                  aria-label={`Borrar filtros. ${filtersApplied} filtros seleccionados`}
                  text={"Borrar filtros"}
                  size={TEXT_SIZE.TEXT_PRESET_02}
                  color={TEXT_COLOR.MOVISTAR_BLUE}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                  decoration={TEXT_DECORATION.UNDERLINE}
                />
              </CustomLink>
            )}
          </div>
          <div className="filters-section">
            <div
              className={`searcher-container ${searcherSelected ? "focused-search" : "blurred-search"
                }`}
            >
              <Searcher
                handleOnFocus={handleFocusSearcher}
                handleOnBlur={handleBlurSearcher}
                placeholder="Modelo, marca..."
                ariaLabel="Buscar un modelo o una marca"
                handleOnSubmit={handleOnSubmitSearcher}
                handleOnChange={handleOnChangeSearcher}
                pageId={id}
              />
            </div>
            <div className="filters-desktop">
              <Filters filters={filtersData} mobile={false} />
            </div>
          </div>
        </div>

        <div className="devicesContainer">
          {orionInfo && orionInfo["cms-ml-alert-1"] && (
            <CmsBlock
              orionInfo={orionInfo}
              alias={orionAlias}
              blockName="cms-ml-alert-1"
              Component={CmsAlert}
            />
          )}
          {
            id === "reacondicionados-outlet" && (
              <RoombaPriceBanner />
            )
          }
          {
            id === "ofertas-movistar-para-el-mundial" && (
              <WorldCupBanner />
            )
          }
          <AlertNewR2R />
          <div className="devicesHeader">
            <div
              className={`devicesMobile ${searcherSelected ? "openSearch" : "notOpenSearch"
                }`}
            >
              <div
                className="devicesMobileHeaderOffers"
              >
                <div className="devicesMobileHeaderContent">
                  <button type="button" className="badgeFiltros" onClick={launchFiltersModal}>
                    {`Orden y filtros ${filtersApplied > 0 ? "(" + filtersApplied + ") " : ""}`}
                    <Icon id="filtro-m" height={18} color="black" />
                  </button>
                  <ButtonFilter />
                </div>
              </div>
            </div>
            <div className="devicesDesktop">
              <div className="devicesCounter">
                <TextInfo
                  text={`${getCategoryTextById(id, categoryName)} disponibles:`}
                  size={TEXT_SIZE.SUBTITLE1}
                  color={TEXT_COLOR.MOVISTAR_BLACK}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                  kind={TEXT_KIND.HEADING}
                  level={TEXT_HEADING_LEVEL.H2}
                />
                <TextInfo
                  text={`${pagination?.totalNumberOfElements}`}
                  size={TEXT_SIZE.SUBTITLE1}
                  color={TEXT_COLOR.MOVISTAR_BLACK}
                  fontType={TEXT_FONT_WEIGHT.BOLD}
                  kind={TEXT_KIND.HEADING}
                  level={TEXT_HEADING_LEVEL.H2}
                />
              </div>
              <DeviceOrder
                sortingKeys={sortingKeysMap}
                orderSelected={orderSelected}
                handleOnChangeOrder={handleOnChangeOrder}
              />
            </div>
          </div>
          {productsCards.length === 0 && !productsFetching && (
            <div
              style={{
                width: "100%",
                height: "500px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "6px",
                }}
              >
                <NotFound />

                <TextInfo
                  text={`No hemos encontrado ningún dispositivo`}
                  size={TEXT_SIZE.T7}
                  color={TEXT_COLOR.MOVISTAR_BLACK}
                  fontType={TEXT_FONT_WEIGHT.BOLD}
                />
                <TextInfo
                  text={`Prueba a modificar la búsqueda o eliminar algún filtro`}
                  size={TEXT_SIZE.BODY1}
                  color={TEXT_COLOR.GREY}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                />
              </div>
            </div>
          )}

          <div
            className={
              productsCards.length > 4 ? "devicesMap" : "devicesMap deviceMapMin"
            }
          >
            {productsCards &&
              productsCards.map((product, index) => {
                if (product.offers) {
                  return (
                    <DeviceCard
                      labelSaving={product.labelSaving}
                      prePriceLabel={product.prePriceLabel}
                      hash={hash}
                      key={`${product.name}-${index}`}
                      cydata={`element card-${index + 1}`}
                      wrapperClass="device"
                      onClick={() => handleCardClick(product, index)}
                      href={product.href}
                      labelPromo={product.labelPromo}
                      image={product.image}
                      name={product.name}
                      pretitle={product.pretitle}
                      financing={product.financing}
                      bottomCardText={product.bottomCardText}
                      offers={product.offers}
                      stamp={product.stamp}
                      regulatoryInfo={product.regulatoryInfo}
                    />
                  );
                } else if (product.banner) {
                  return (
                    <div
                      className="device-card"
                      key={`${product.banner.id}-${index.toString()}`}
                    >
                      <CustomizerComponent
                        hash={hash}
                        name={product.banner.id}
                        Component={Card}
                        FallbackComponent={FakeCardDevice}
                        forceReload
                      />
                    </div>
                  );
                }
              })}
          </div>
        </div>
      </div>
      <Pagination />
      <FiltersMobileButton
        text={`Orden y filtros ${filtersApplied > 0 ? "(" + filtersApplied + ") " : ""
          }`}
        handleClick={launchFiltersModal}
      />
      <style jsx>{styles}</style>
    </section>
  );
};

export default Devices;
